module.exports = __webpack_public_path__ + "cec5f082e08fd3d7a72145513f82e9af.pdf";